(ns com.theplantscape.calculate.haversine)



(def earth-radius-km 6372.795477598)
(def kilometers-to-miles 0.6214)
(def one-latitude-in-miles 54.6)
(def one-latitude-in-feet  364812.992)
(def one-latitude-in-meters 111195.00)
(def one-longitude-in-meters 71474.00)
(def one-longitude-in-feet 234494.75)
(def conversions {:latitude {:meters one-latitude-in-meters
                             :feet one-latitude-in-feet
                             :kilometers 69.21}
                  :longitude {:meters one-longitude-in-meters
                              :feet 364000.00}})

(defn to-radians [degrees]
  (* degrees (/ (.-PI js/Math ) 180)))

(defn sin2 [x]
  (.pow js/Math (.sin js/Math x) 2))

(defn distance
    "Calcula distância entre duas coordenadas geográficas em metros"
    ([latlng1 latlng2]
        #_{:pre [every? (every-pred map? #(contains? % :lat) #(contains? % :lng)) [latlng1 latlng2]]}
     (let [lat1 (to-radians (first latlng1))
           lng1 (to-radians (second latlng1))
           lat2 (to-radians (first latlng2))
           lng2 (to-radians (second latlng2))
           half-dlat (/ (- lat2 lat1) 2)
           half-dlng (/ (- lng2 lng1) 2)
   
           a (+ (sin2 half-dlat) (* (.cos js/Math lat1) (.cos js/Math lat2) (sin2 half-dlng)))]
               (prn lat1)
           (prn half-dlat)
           (prn half-dlng)

       (* 2000 earth-radius-km (.atan2 js/Math (.sqrt js/Math a) (.sqrt js/Math (- 1 a)))))))

(defn distance2
    "Calcula distância entre duas coordenadas geográficas em metros"
    ([latlng1 latlng2]
        #_{:pre [every? (every-pred map? #(contains? % :lat) #(contains? % :lng)) [latlng1 latlng2]]}
     (let [lat1 (to-radians (first latlng1))
           lng1 (to-radians (second latlng1))
           lat2 (to-radians (first latlng2))
           lng2 (to-radians (second latlng2))

           ;;haversine formula
           half-dlat (/ (- lat2 lat1) 2)
           half-dlng (/ (- lng2 lng1) 2)
           a (+ (sin2 half-dlat) (* (.cos js/Math lat1) (.cos js/Math lat2) (sin2 half-dlng)))
           c (* 2 (.asin js/Math (.sqrt js/Math a)))
           ]
       (prn "---- 2")
       (prn lat1)
       (prn half-dlat)
       (prn half-dlng)
       (prn c)
       (prn (* c earth-radius-km))
       (* c earth-radius-km)
       #_(* 2000 earth-radius-km (.atan2 js/Math (.sqrt js/Math a) (.sqrt js/Math (- 1 a)))))))



(defn distance-lat [lat1 lat2 dimension]
  (* (get-in conversions [:latitude dimension]) (- lat1 lat2) ))

(defn distance-long [long1 long2 dimension]
  ;; TODO need to calculate using sin
  ;(distance-lat lat1 lat2 dimension)
 ; (.cos js/Math)
;  (* (get conversions dimension) (- 51.23535 51.23533) )
  (* (get-in conversions [:longitude dimension]) (- long1 long2) ))

(defn distance-lat-long [[lat1 long1] [lat2 long2] dimension]
  [(distance-lat lat1 lat2 dimension)
   (distance-long long1 long2 dimension)])

(comment 
  (* 180 (/ 180 (.-PI js/Math ) ))
  (*  180 (/  (.-PI js/Math ) 180))
  (.sin js/Math 4)
  (to-radians 180)
  (to-radians 22.664823)
  (* (distance [51.2423445, 0.498387] [51.24237, 0.50826]) 1000)
  (distance [51.2423445, 0.498387] [51.24237, 0.50826])
  (distance [22.664823 11.161030] [32.208499 10.741567])
  (distance2 [22.664823 11.161030] [32.208499 10.741567])
  (* 0.6214 (distance [51.24234, 0.50457] [51.24226, 0.49560])) ;; 606.47
  (distance [51.24234, 0.50457] [51.24226, 0.49560]) ;; 606.47
  (distance2 [51.24234, 0.50457] [51.24226, 0.49560])

  (* one-latitude-in-miles (- 51.24234 51.24226))
  (* one-latitude-in-meters (- 51.24234 51.24226) )
  (* one-latitude-in-meters (- 51.23535 51.23533) )
  (distance-long 51.23533 51.23535 :meters)
  (distance-lat 51.23533 51.23535 :meters)
  (distance-lat 51.23535 51.23533 :meters)
  (distance-lat 51.23535 51.23533 :feet)
  (distance-lat-long [51.2701361 0.552636] [52.2701361 0.552636] :feet)
  (* one-latitude-in-feet (- 51.24234 51.24226) )
  


  ;; (map to-radians [1 2 3 4])
  ;; 51.2423445, 0.498387
  ;; 51.24237, 0.50826
  ;; 500 m


  ;;51.24234, 0.50457
  ;;51.24226, 0.49560
  ;; google 606.47 - omni cal 0.6245

  ;; 51.23533, 0.49011
  ;; 51.23535, 0.49002
  ;; google 6.30 meters - omni cal 2.224

  )
